import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { Pagination } from "@customTypes/index";
import { Medication } from "@customTypes/prescription";

import { prescriptionQKeys } from "./queryKeys";


const select = (res: any) => {
  // console.log(res.data);
  const pagination: Pagination = {
    page: res.data.pagination.page,
    pageCount: res.data.pagination.page_count,
    pageSize: res.data.pagination.page_size,
    total: res.data.pagination.total,
  };

  if (res.data.data.length) {
    const newData: Medication[] = [];

    for (const i in res.data.data) {
      const {
        _id,
        medication_name,
        frequency,
        dosage,
        duration,
        reason,
        prescription_id,
        created_at,
        updated_at,
      } = res.data.data[i];

      newData.push({
        id: _id,
        name: medication_name,
        frequency,
        dosage,
        duration,
        reason,
        prescriptionId: prescription_id,
        createdAt: new Date(created_at),
        updatedAt: new Date(updated_at),
      });
    }

    // console.log(newData);
    return {
      newData,
      pagination,
    };
  }
  return null;
};

interface QueryProps {
  patientId: string; //* Don't need this for medication, but I'm temporarily using another endpoint
  prescriptionId: string;
  isEnabled?: boolean;
  pagination?: Partial<Pagination>;
  search?: string;
}

export const useGetMedicationsForPrescription = ({
  prescriptionId,
  isEnabled = true,
  patientId,
  pagination,
  search = "",
}: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: prescriptionQKeys.medicationWithFilters(prescriptionId, {
      pagination,
      ...(search && { search }),
    }),
    queryFn: () => {
      // return api.get(`medication/prescription/${prescriptionId}`);
      return api.get(`medication/patient/${patientId}`, {
        params: {
          prescription_id: prescriptionId,
          ...(search && { search }),
          ...(pagination && {
            page: pagination.page,
            page_size: pagination.pageSize,
          }),
        },
      });
    },
    select,
    enabled: isEnabled,
    staleTime: Infinity,

    onError: (res: any) => {
      console.error("[From Get Medications for Prescription id]", res);
      handleErrors(res, "query");
    },
  });
};
